export const phoneTypeTypes = [
  { label: 'Home', value: 'Home' },
  { label: 'Work', value: 'Work' },
  { label: 'Mobile', value: 'Mobile' },
  { label: 'Fax', value: 'Fax' }
]
